﻿export { NetworkIndicatorTool };

/**
 * Class NetworkIndicatorTool
 */
const NetworkIndicatorTool = function () {

    //Define this
    var myNetworkIndicatorTool = this;

    // -- begin public variable -------------------------------------------------------------------

    // Datable notification info
    this.datatableNotificationInfo = null;

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private variable ------------------------------------------------------------------

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Init NetworkIndicatorTool
     */
    this.InitNetworkIndicatorTool = function () {

        $('#id-modal-network-indicator-tool').modal('show');

    };

    this.BuildIndicator = function () {

        $.ajax({
            type: 'POST',
            url: '/Indicator/GenerateReport',
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na construção das plantas de localização");
                } else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            var attempts = 0;
                            var pdfUrl = "/templates/territorial_management/export/" + data.result.fileName;
                            var fileExists = false;
                            window['callAttempts'] = 0;
                            window['callFile'] = function () {

                                // Set download retry if report pdf still does not exist on server
                                setTimeout(function () {
                                    fileExists = myTerritorialManagement._UrlExists(pdfUrl);
                                    attempts++;

                                    if (myTerritorialManagement._UrlExists(pdfUrl)) {

                                        // Render PDF File 
                                        var openPdfDirect = true; // Alway open in PDF canvas (window.navigator.userAgent.toLowerCase().indexOf('firefox')>= 0);
                                        if (openPdfDirect) {
                                            window.location.assign(pdfUrl);
                                            return;
                                        }
                                        var url = pdfUrl;
                                        var thePdf = null;
                                        var scale = 1.5;

                                        // Show report on print preview mode
                                        PDFJS.getDocument(url).promise.then(function (pdf) {
                                            thePdf = pdf;
                                            var viewer = document.getElementById('pdf-display');

                                            for (var page = 1; page <= pdf.numPages; page++) {
                                                var canvas = document.createElement("canvas");
                                                canvas.className = 'pdf-page-canvas';
                                                viewer.appendChild(canvas);
                                                renderPage(page, canvas);
                                            }
                                        });

                                        function renderPage(pageNumber, canvas) {
                                            thePdf.getPage(pageNumber).then(function (page) {
                                                var viewport = page.getViewport(scale);
                                                canvas.height = viewport.height;
                                                canvas.width = viewport.width;
                                                page.render({ canvasContext: canvas.getContext('2d'), viewport: viewport });
                                            });
                                        }
                                        attempts = 10;

                                        // Show button
                                        $('#id-plant-report-pdf-btn').show();
                                        $('#id-plant-report-print-btn').show();

                                        myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    } else {
                                        if (window['callAttempts'] < 20) {
                                            window['callAttempts']++;
                                            window['callFile']();
                                        }
                                    }
                                }, (attempts > 0 ? 1000 : 1));
                            }
                            window['callFile']();

                            // Print pdf button
                            $('#id-plant-report-print-btn').off('click').on('click', function () {
                                myTerritorialManagement._PrintPdf(pdfUrl);
                            });

                            // Download pdf button
                            $('#id-plant-report-pdf-btn').off('click').click(function () {
                                var link = document.createElement('a');
                                link.href = pdfUrl;
                                link.download = 'planta-localizacao-' + myTerritorialManagement._locationPlantProcessNumber + '.pdf';
                                link.dispatchEvent(new MouseEvent('click'));
                            });
                            break;
                        default:
                            toastr["error"]("Erro na construção das plantas de localização");
                            myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na construção das plantas de localização");
                myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });

    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init ogc layer tool
 * @param {object} mapSgs, map object
 */
NetworkIndicatorTool.prototype.Init = function (mapSgs) {
    // Set map info
    this._mapSgs = mapSgs;

    
}